import React, { useState, useRef, useEffect } from 'react';
import { Button, Card, Col, DatePicker, Form, Input, Row, Table, Typography } from 'antd';
const { RangePicker } = DatePicker;
import { useForm } from 'antd/lib/form/Form';
import { CollectionsService } from '@gtpl/shared-services/finance';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { DutyDrawBackDateReq } from '@gtpl/shared-models/finance';
import moment from 'moment';

const AbstractDutyDrawBackReport = () => {
const { Text } = Typography;
const [form] = useForm();
const Service = new CollectionsService();
const [getAllData,setGetAllData] = useState([])
  const [selectedEstimatedFromDate, setSelectedEstimatedFromDate] = useState(undefined);
  const [selectedEstimatedToDate, setSelectedEstimatedToDate] = useState(undefined);
 

  const getDutyDrawBackData =(onReset = false) => {
    let fromDate = onReset ? undefined : selectedEstimatedFromDate;
    let toDate = onReset ? undefined : selectedEstimatedToDate;
    const req = new DutyDrawBackDateReq()
    req.fromDate = fromDate?moment(fromDate).format('YYYY-MM-DD'):undefined
    req.toDate = toDate?moment(toDate).format('YYYY-MM-DD'):undefined
    Service.getDutyDrawBackTotals(req)
    .then((res) => {
      if(res.status){
        if (res.data && Array.isArray(res.data) && res.data.length > 0) {

          const totalBmrIndToBeReceived = res.data.reduce((acc, item) => acc + Number(item.bmrIndToBeRecived || 0), 0);
          const totalBmrExportsToBeReceived = res.data.reduce((acc, item) => acc + Number(item.bmrExportstoBeRecived || 0), 0);
          const totalBmrIndReceived = res.data.reduce((acc, item) => acc + Number(item.bmrIndReceived || 0), 0);
          const totalBmrExportsReceived = res.data.reduce((acc, item) => acc + Number(item.bmrExportsReceived || 0), 0);
  
          const transformedData = [
            {
              key: "1",
              particulars: "To Be Received",
              bmrIpl: totalBmrIndToBeReceived.toFixed(2),
              bmrExports: totalBmrExportsToBeReceived.toFixed(2),
              total: (totalBmrIndToBeReceived + totalBmrExportsToBeReceived).toFixed(2),
            },
            {
              key: "2",
              particulars: "Received",
              bmrIpl: totalBmrIndReceived.toFixed(2),
              bmrExports: totalBmrExportsReceived.toFixed(2),
              total: (totalBmrIndReceived + totalBmrExportsReceived).toFixed(2),
            },
          ];
  
          setGetAllData(transformedData);
        //   console.log(transformedData, "qqqqqqqqqqqqqqqqqq");
        } 
      }
        else {
          setGetAllData([])
          AlertMessages.getErrorMessage("No data available");
        }
      })
      .catch((err) => {
        AlertMessages.getErrorMessage(err.internalMessage || "Error fetching data");
      });
  };

  useEffect(() => {
    getDutyDrawBackData();
  }, []);

  const onReset = () => {
    getDutyDrawBackData()
    form.resetFields();
    setSelectedEstimatedFromDate(undefined);
    setSelectedEstimatedToDate(undefined);
    setGetAllData([]);
  };

  const columns = [
    {
      title: "Particulars",
      dataIndex: "particulars",
      key: "particulars",
      width: "30%",
    //   ...getColumnSearchProps("particulars"),
    },
    {
      title: "BMR IPL",
      dataIndex: "bmrIpl",
      key: "bmrIpl",
       render:(val,text)=>{
        return(
          <span>{Number(text.bmrIpl).toLocaleString()}</span>
        )
      }
    },
    {
      title: "BMR Exports",
      dataIndex: "bmrExports",
      key: "bmrExports",
       render:(val,text)=>{
        return(
          <span>{Number(text.bmrExports).toLocaleString()}</span>
        )
      }
    },
    {
      title: "Total",
      dataIndex: "total",
      key: "total",
       render:(val,text)=>{
        return(
          <span>{Number(text.total).toLocaleString()}</span>
        )
      }
    },
  ];

  const EstimatedETDDate = (value) => {
    if (value) {
      const fromDate = new Date(value[0].format('yyyy-MM-DD'));
      const toDate = new Date(value[1].format('yyyy-MM-DD'));
      setSelectedEstimatedFromDate(fromDate);
      setSelectedEstimatedToDate(toDate);
    }
  };

  return (
    <Card
    size="small"
    title={<span style={{ color: 'white' }}>ABSTRACT DUTY DRAW BACK </span>}
    style={{ textAlign: 'center' }}
    headStyle={{ backgroundColor: '#69c0ff', border: 0 }}
  >
    
   <Form layout='vertical' form={form}>
<Row gutter={16} align="middle">
<Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 10 }} lg={{ span: 8 }} xl={{ span: 6 }}>
    <Form.Item
      name="fromDate"
      label="Shipping Bill Date"
      initialValue={undefined}
      rules={[
        {
          required: false,
          message: "Select date range"
        },
      ]}
    >
      <RangePicker onChange={EstimatedETDDate} />
    </Form.Item>
  </Col>
  <Col style={{ paddingLeft: '10px', marginTop: '7px' }}>
    <Button 
      type="primary" 
      
    //   disabled={disable} 
      onClick={() => getDutyDrawBackData()}
    >
      Get Report
    </Button>
  </Col>
  <Col style={{ paddingLeft: '10px', marginTop: '7px' }}>
    <Button 
      
      type="primary" 
     
      onClick={onReset}
    > 
      Reset 
    </Button>
  </Col>
</Row>
</Form>
{getAllData.length>0?(
    <Table
      size="small"
      columns={columns}
      dataSource={getAllData}
      bordered
      summary={(pageData) => {
        let totalBmrIpl = 0;
        let totalBmrExports = 0;
        let totalSum = 0;
      
        pageData.forEach(({ bmrIpl, bmrExports, total }) => {
          totalBmrIpl += Number(bmrIpl) || 0;
          totalBmrExports += Number(bmrExports) || 0;
          totalSum += Number(total) || 0;
        });

        return (
          <Table.Summary.Row>
            <Table.Summary.Cell index={0}><Text>Total</Text></Table.Summary.Cell>
            <Table.Summary.Cell index={1} align="right"><Text>{totalBmrIpl.toFixed(2)}</Text></Table.Summary.Cell>
            <Table.Summary.Cell index={2} align="right"><Text>{totalBmrExports.toFixed(2)}</Text></Table.Summary.Cell>
            <Table.Summary.Cell index={3} align="right"><Text>{totalSum.toFixed(2)}</Text></Table.Summary.Cell>
          </Table.Summary.Row>
        );
      }}
    />
    ):('No Data found')}
  </Card>
);
};

export default AbstractDutyDrawBackReport;
